import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { ApiService } from 'src/app/core/service/api.service';

const state = {
    checkoutItems: JSON.parse(localStorage['checkoutItems'] || '[]')
}

@Injectable({
    providedIn: 'root'
})
export class OrderService {

    constructor(private router: Router, private _apiService: ApiService) { }

    // Get Checkout Items
    public get checkoutItems(): Observable<any> {
        const itemsStream = new Observable(observer => {
            observer.next(state.checkoutItems);
            observer.complete();
        });
        return <Observable<any>>itemsStream;
    }

    // Create order
    public createOrder(product: any, details: any, orderId: any, amount: any) {
        var item = {
            shippingDetails: details,
            product: product,
            orderId: orderId,
            totalAmount: amount
        };
        state.checkoutItems = item;
        localStorage.setItem("checkoutItems", JSON.stringify(item));
        // localStorage.removeItem("cartItems");
        return this._apiService.get(`customer/order/place?customer_id=82&is_guest=1`, item).pipe(
            tap(() => {
                this.router.navigate(['/shop/checkout/success', orderId]);
            })
        );

        // this.router.navigate(['/shop/checkout/success', orderId]);
    }

    getOrderDetails(orderId: number, isGuest: boolean, customerId: number, guestId?: number): Observable<any> {
        // Construct HTTP query parameters
        let params = new HttpParams()
          .set('order_id', orderId)
          .set('customer_id', customerId)
        //   .set('is_guest', isGuest ? '1' : '0');

        // if (isGuest && guestId) {
        //   params = params.set('guest_id', guestId.toString());
        // }

        // Make the GET request
          return this._apiService.get<any>(`customer/order/details`, { params });
      }
}
